import { useNavigate } from "react-router";

import { TableDataCell } from "@digital-services/ui";

import { editApiUserRouteOnTab1 } from "@api-users/common";

import { formatterShort } from "@utils/time-utils";

import { AzureApplicationUserModel } from "../../models/api-users-models";
import { ApiUserSecretStatusIcon } from "../ApiUserSecretStatusIcon";

interface Props {
  apiUser: AzureApplicationUserModel;
}

export const ApiUsersDataRow = (props: Readonly<Props>) => {
  const { apiUser } = props;
  const navigate = useNavigate();

  const onRowClick = async () => {
    await navigate(editApiUserRouteOnTab1(apiUser.id));
  };

  return (
    <tr
      className="hover:cursor-pointer"
      onClick={false ? onRowClick : () => {}}
    >
      <TableDataCell>{apiUser.name}</TableDataCell>
      <TableDataCell>{apiUser.id}</TableDataCell>
      <TableDataCell>{formatterShort(apiUser.createdOn)}</TableDataCell>
      <TableDataCell>
        <ApiUserSecretStatusIcon secretStatus={apiUser.secretStatus} />
      </TableDataCell>
    </tr>
  );
};
